
    <div class="modal-header align-items-center lookup-header">
        <h6 class="pointer" (click)="close()">
            Back To Saved Addresses
        </h6>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="close()">
            <span class="" aria-hidden="true"> × </span>
        </button>
    </div>

    <div class="modal-body add-address-modal">
        <div class="lookup-card d-flex align-items-center flex-column bg-white">
            <h1>{{'Add New Address'}}</h1>
            <p>{{'Please add customers address details below'}}</p>
            <form #addressForm="ngForm">
                <div class="row">
                    <div class="col-md-6">
                        <label for="title">Address Title (ex: Home, Work ..etc)</label>
                        <input type="text" name="title" id="title" [(ngModel)]="newAddress && newAddress.title" required class="w-100"
                            #title="ngModel" appCheckValidity [appCheckValidity]="title">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <label for="title">City</label>
                        <select name="city" id="city" (change)="onCityChange($event.target.value)">
                            <option disabled selected>Select City</option>

                            <option *ngFor="let city of cityList" [selected]="newAddress.cityId == city.id"
                                [value]="city.id">{{city.enName}}</option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <label for="title">Area</label>
                        <select name="areaId" id="area" (change)="onAreaChange($event.target.value)" [ngModel]="newAddress?.areaId">
                            <option disabled [selected]="!newAddress.areaId">Select Area</option>
                            <option *ngFor="let area of areaList"
                                [value]="area.id" [selected]="newAddress.areaId == area.areaId">{{area.enName}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <label for="address">Address</label>
                        <textarea name="address" id="address" cols="30" rows="2"
                            [(ngModel)]="newAddress && newAddress.details" required #address="ngModel" appCheckValidity
                            [appCheckValidity]="address"></textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <label for="bNum">Building Number</label>
                        <input required type="text" name="bNum" id="bNum" class="w-100"
                            [(ngModel)]="newAddress && newAddress.buildingNumber" #bNum="ngModel" appCheckValidity
                            [appCheckValidity]="bNum">
                    </div>

                    <div class="col-md-6">
                        <label for="floorNum">Floor Number</label>
                        <input required type="number" name="floorNum" id="floorNum" class="w-100" min="0"
                            [(ngModel)]="newAddress && newAddress.floorNumber" #floorNum="ngModel" appCheckValidity
                            [appCheckValidity]="floorNum">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <label for="apNum">Apartment Number</label>
                        <input type="number" name="apNum" id="apNum" class="w-100" min="0"
                            [(ngModel)]="newAddress && newAddress.apartmentNumber" #apNum="ngModel" appCheckValidity
                            [appCheckValidity]="apNum">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">

                        <label for="additionalDetails">Additional Details</label>
                        <textarea name="additionalDetails" id="additionalDetails" cols="30" rows="2"
                            [(ngModel)]="newAddress && newAddress.additionalDetails"></textarea>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <!-- <span class="link-another color-primary mb-4" *ngIf="userExists == true || userExists == false"
            (click)="onReset(addressForm)">Try Another Number!</span>-->
        <button [ngClass]="{'loading': loading}" type="submit" class="btn btn-psp-primary  btn-round"
            [disabled]="!addressForm.valid" (click)="onSubmit()" > Save </button>

            <button type="submit" class="btn btn-psp-primary btn-round" (click)="close()"> Close </button>
    </div>
